module.exports = __webpack_public_path__ + "media/case-notification.755bde38.mp3";